import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { Play, Calendar, ChevronRight, Trophy } from "lucide-react";
import { API } from "@/config";

export default function TBTPage() {
  const [videos, setVideos] = useState([]);
  const [loading, setLoading] = useState(true);
  
  useEffect(() => {
    fetchTBTVideos();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps -- mount-only fetch
  
  const fetchTBTVideos = async () => {
    try {
      const res = await axios.get(`${API}/videos?category=tbt&limit=200`);
      setVideos(res.data);
    } catch (err) {
      console.error("Error fetching TBT videos:", err);
    } finally {
      setLoading(false);
    }
  };
  
  if (loading) {
    return (
      <div className="loading">
        <div className="loading-spinner"></div>
      </div>
    );
  }
  
  return (
    <div className="container" style={{ padding: '2rem 1rem 4rem' }}>
      <nav className="breadcrumb">
        <Link to="/vault">The Vault</Link>
        <ChevronRight size={16} className="breadcrumb-separator" />
        <span>TBT</span>
      </nav>
      
      <div className="section-header">
        <div>
          <h1 className="section-title" style={{ fontSize: '2rem' }}>TBT - The Basketball Tournament</h1>
          <p style={{ color: 'var(--text-secondary)', marginTop: '0.5rem' }}>La Familia - Former Kentucky Wildcats competing in The Basketball Tournament</p>
        </div>
        <span className="btn btn-secondary" style={{ cursor: 'default' }}>
          <Trophy size={16} />
          {videos.length} {videos.length === 1 ? 'Game' : 'Games'}
        </span>
      </div>
      
      {videos.length === 0 ? (
        <div className="empty-state">
          <Trophy className="empty-state-icon" />
          <h3 className="empty-state-title">No TBT Games Yet</h3>
          <p className="empty-state-text">TBT games will be added when the tournament begins.</p>
        </div>
      ) : (
        <div className="video-grid">
          {videos.map((video) => (
            <Link 
              key={video.id} 
              to={`/watch/${video.id}`} 
              className="video-card"
              data-testid={`tbt-video-${video.id}`}
            >
              <div className="video-card-thumbnail">
                <img 
                  src={video.thumbnail || 'https://images.unsplash.com/photo-1546519638-68e109498ffc?w=400&q=80'} 
                  alt={video.title}
                />
                <div className="video-card-play">
                  <div className="video-card-play-icon">
                    <Play size={24} />
                  </div>
                </div>
                {video.duration && (
                  <span className="video-card-duration">{video.duration}</span>
                )}
              </div>
              <div className="video-card-body">
                <h3 className="video-card-title">{video.title}</h3>
                <div className="video-card-meta">
                  <span className="video-card-meta-item">
                    <Calendar size={14} />
                    {video.date}
                  </span>
                  {video.opponent && (
                    <span className="video-card-meta-item">
                      vs {video.opponent}
                    </span>
                  )}
                </div>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
